// ==============================|| CUSTOM FUNCTION - COLORS ||============================== //

import type { Theme } from '@mui/material/styles';

type ColorKey = 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success';

export type ColorTokens = {
  lighter: string;
  light: string;
  main: string;
  dark: string;
  darker: string;
  contrastText: string;
};

type ThemeVarsWithPalette = NonNullable<Theme['vars']> & {
  palette: Record<ColorKey, ColorTokens>;
};

function toColorTokens(color: Partial<ColorTokens>): ColorTokens {
  const main = color.main ?? '';
  const light = color.light ?? main;
  const dark = color.dark ?? main;

  return {
    lighter: color.lighter ?? light,
    light,
    main,
    dark,
    darker: color.darker ?? dark,
    contrastText: color.contrastText ?? '#fff'
  };
}

export default function getColors(theme: Theme, color: ColorKey | string): ColorTokens {
  const vars = theme.vars as ThemeVarsWithPalette | undefined;

  switch (color) {
    case 'secondary':
      return vars?.palette.secondary ?? toColorTokens(theme.palette.secondary);
    case 'error':
      return vars?.palette.error ?? toColorTokens(theme.palette.error);
    case 'warning':
      return vars?.palette.warning ?? toColorTokens(theme.palette.warning);
    case 'info':
      return vars?.palette.info ?? toColorTokens(theme.palette.info);
    case 'success':
      return vars?.palette.success ?? toColorTokens(theme.palette.success);
    default:
      return vars?.palette.primary ?? toColorTokens(theme.palette.primary);
  }
}
